import * as S from './index.style'
import { DadosComponentesProjeto, inicializarDadosTabelaComponenteProjeto } from 'models/Viabilidade/DadosComponentesProjeto'
import { ElementType, useState } from 'react'
import { InputBaseComponentProps, Table, TableBody, TableHead, TableRow, TextField } from '@material-ui/core'
import { MascaraDecimal } from 'components/Mascara/Decimal'
import { secaoOpcional } from 'helpers/Constantes/Mensagens'

const ComponentesProjeto: React.FC<{
  dadosComponentesProjeto: DadosComponentesProjeto
  dadosComponentesProjetoHandler: (novoValor: DadosComponentesProjeto) => void
}> = ({ dadosComponentesProjeto, dadosComponentesProjetoHandler }) => {
  const [valores, setValores] = useState(dadosComponentesProjeto)

  const camposHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    const state = { ...valores, [event.target.name]: event.target.value }
    setValores(state)
    dadosComponentesProjetoHandler(state)
  }

  const dadosTabelaComponentesProjeto = inicializarDadosTabelaComponenteProjeto(dadosComponentesProjeto)

  return (
    <S.Wrapper data-cy="sessaoComponentesProjeto">
      <S.NomeSecao>
        Componentes do Projeto <S.SecaoOpcional>{secaoOpcional}</S.SecaoOpcional>
      </S.NomeSecao>
      <S.TableContainerCustomizado>
        <Table>
          <TableHead data-cy="tableHead">
            <S.TableCellCustomizado>Componentes de Projeto</S.TableCellCustomizado>
            <S.TableCellCustomizado>Área (m²)</S.TableCellCustomizado>
          </TableHead>
          <TableBody>
            {dadosTabelaComponentesProjeto.map((componenteProjeto) => (
              <TableRow key={componenteProjeto.id}>
                <S.TableCellCustomizado>{componenteProjeto.descricao}</S.TableCellCustomizado>
                <S.TableCellCustomizado>
                  <TextField
                    placeholder="00,00"
                    type="text"
                    name={componenteProjeto.nome}
                    data-cy={'campo' + componenteProjeto.nome}
                    value={componenteProjeto.valor}
                    onChange={camposHandler}
                    variant="outlined"
                    size="small"
                    InputProps={{
                      inputComponent: MascaraDecimal as unknown as ElementType<InputBaseComponentProps>,
                      'aria-label': 'naked'
                    }}
                  />
                </S.TableCellCustomizado>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </S.TableContainerCustomizado>
    </S.Wrapper>
  )
}

export default ComponentesProjeto
